export const Connector = () => {
  return (
    <div className="right-1/2 top-11 w-px bottom-0 bg-neutral-primary absolute opacity-30"/>
  );
}